import graphql from "babel-plugin-relay/macro";

const GetDestinationListingQuery = graphql`
  query GetDestinationListingQuery($cityId: Int!, $searchTerm: String) {
    getDestinationsBySource(cityId: $cityId, searchTerm: $searchTerm) {
      CMCityname
      CMCityid
      pickupDropPoints {
        cityId
        name
        id
      }
    }
  }
`;
export default GetDestinationListingQuery;
